// dropzone file extensions - start

// application types
export const pdf = {"application/pdf": [".pdf"]}
export const doc = {"application/msword": [".doc"]}
export const docx = {"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"]}
export const xls = {"application/vnd.ms-excel": [".xls"]}
export const xlsx = {"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]}
export const zip = {"application/zip": [".zip"]}
//text types
export const csv = {"text/csv": [".csv"]}
export const txt = {"text/plain": [".txt"]}
export const rtf = {"text/rtf": [".rtf"]}
export const html = {"text/html": [".html", ".htm"]}
//audio types
export const mp3 = {"audio/mpeg": [".mp3"]}
export const wma = {"audio/x-ms-wma": [".wma"]}
//video types
export const mpg = { "video/mpeg": [".mpg", ".mpeg"] };
export const flv = { "video/x-flv": [".flv"] };
export const avi = { "video/x-msvideo": [".avi"] };
export const mp4 = { "video/mp4": [".mp4"] };
export const ogv = { "video/ogg": [".ogv"] };
export const ts = { "video/mp2t": [".ts"] };
export const webm = { "video/webm": [".webm"] };
export const mkv = { "video/x-matroska": [".mkv"] };
export const mov = { "video/quicktime": [".mov"] };
export const wmv = { "video/x-ms-wmv": [".wmv"] };
export const video3gp = { "video/3gpp": [".3gp"] };
export const video3g2 = { "video/3gpp2": [".3g2"] };
export const m4v = { "video/x-m4v": [".m4v"] };
export const asf = { "video/x-ms-asf": [".asf"] };
export const f4v = { "video/mp4": [".f4v"] }; // F4V is a variant of MP4
export const rm = { "application/vnd.rn-realmedia": [".rm"] };
export const rmvb = { "application/vnd.rn-realmedia-vbr": [".rmvb"] };
export const mxf = { "application/mxf": [".mxf"] };
export const vob = { "video/dvd": [".vob"] };
export const dv = { "video/dv": [".dv"] };
export const amv = { "video/x-amv": [".amv"] };
export const mpeg = { "video/mpeg": [".mpeg"] }; // Alternative for MPEG
//image types
export const jpeg = {"image/jpeg": [".jpg", ".jpeg"]}
export const png = {"image/png": [".png"]}
export const gif = {"image/gif": [".gif"]}
export const bmp = {"image/bmp": [".bmp"]};
export const tiff = { "image/tiff": [".tif", ".tiff"] };

// dropzone file extensions - end

export const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

export const CAN_ACCESS_APPLICATION = {
  DASHBOARD : "DASHBOARD",
  IVR_MANAGEMENT : "IVR_MANAGEMENT",
  ORDER_MANAGEMENT : "ORDER_MANAGEMENT",
  CLAIM_MANAGEMENT : "CLAIM_MANAGEMENT",
  USER_MANAGEMENT : "USER_MANAGEMENT",
  USER_CREATE : "USER_CREATE",
  PRACTICE : "PRACTICE",
  PATIENT: "PATIENT",
  PRODUCTS : "PRODUCTS",
  TEMPLATES : "TEMPLATES",
  PROVIDER : "PROVIDER",
  PRODUCT_AGREEMENT : "PRODUCT_AGREEMENT",
  AGENCY_MANAGEMENT : "AGENCY_MANAGEMENT",
  INVOICE_MANAGEMENT : "INVOICE_MANAGEMENT",
  DOCUMENT_MANAGEMENT : "DOCUMENT_MANAGEMENT",
  BAA_MANAGEMENT : "BAA_MANAGEMENT",
  CONFIG_MANAGEMENT:"CONFIG_MANAGEMENT",
  AUDITLOG_MANAGEMENT:"AUDITLOG_MANAGEMENT",
  MANUFACTURER_MANAGEMENT:"MANUFACTURER_MANAGEMENT",
  HEALING_BIOLOGIX: "HEALING_BIOLOGIX",
  PRODUCT_SEARCH : "PRODUCT_SEARCH",
  PROVIDER_MANAGEMENT: "PROVIDER_MANAGEMENT",
  PATIENT_MANAGEMENT: "PATIENT_MANAGEMENT",
  INBOX_MANAGEMENT: "INBOX_MANAGEMENT",
  NOTIFICATION_MANAGEMENT: "NOTIFICATION_MANAGEMENT",
  PAYMENT_MANAGEMENT: "PAYMENT_MANAGEMENT",
  COMMISSION_MANAGEMENT:"COMMISSION_MANAGEMENT",
  JOB_SCHEDULER_MANAGEMENT:"JOB_SCHEDULER_MANAGEMENT",
  MEDICAL_NOTE_AUDIT: "MEDICAL_NOTE_AUDIT", //CS-1595
  AI_AUDIT_LIST: "AI_AUDIT_LIST", // AI Medical Audit page
  FACESHEET: "FACESHEET", // CS-1790
  EXPLORE_MARKET: "EXPLORE_MARKET",
  //CS-1731
  AGREEMENT_REQUEST_MANAGEMENT: "AGREEMENT_REQUEST_MANAGEMENT",
  PRESCRIPTION_MANAGEMENT: "PRESCRIPTION_MANAGEMENT",
  SERVER_MANAGEMENT: "SERVER_MANAGEMENT", // CS-2018 - EC2 server dashboard
}

export const CAN_ACCESS_QUICK_ACTION = {
  ADD_PATIENT: "ADD_PATIENT",
  SUBMIT_IVR: "SUBMIT_IVR",
  PLACE_ORDER: "PLACE_ORDER",
  RECORD_TX: "RECORD_TX",
  RETURN_PRODUCT: "RETURN_PRODUCT",
  PAY_INVOICE: "PAY_INVOICE",
  IVR_LIST: "IVR_LIST",
  ORDER_LIST: "ORDER_LIST",
  PRACTICE_LIST: "PRACTICE_LIST",
  PRODUCT_AGREEMENT_LIST: "PRODUCT_AGREEMENT_LIST",
  USER_LIST: "USER_LIST",
  INVOICE_LIST: "INVOICE_LIST",
  PRODUCT_LIST: "PRODUCT_LIST",
  PATIENT_LIST: "PATIENT_LIST",
  //CS-1745 - START
  MANAGE_PRODUCT: "MANAGE_PRODUCT",
  CREATE_OR_APPLY_INV: "CREATE_OR_APPLY_INV",
  CREATE_AGREEMENT: "CREATE_AGREEMENT",
  RECORD_CREDIT_MEMO: "RECORD_CREDIT_MEMO",
  MANAGE_USER: "MANAGE_USER",
  MANAGE_PRACTICE: "MANAGE_PRACTICE"
  //CS-1745 - END
}

// CS-1758 - Create patient flow source constants
export const CREATE_PATIENT_FLOW_SOURCE = {
  MANUAL: "MANUAL",
  FACESHEET: "FACESHEET",
};

export const AI_SERVICE_NAME = {
  MEDICAL_AUDIT_NOTE: "MEDICAL_AUDIT_NOTE",
  FACESHEET: "FACESHEET",
};

export const ORDER_DETAILS_BUTTONS = {
  SALES_INVOICE:"SALES_INVOICE",
};
export const USER_ROLES = {
  ROLE_ADMIN : "ROLE_ADMIN",
  ROLE_PRACTICEADMIN : "ROLE_PRACTICEADMIN",
  ROLE_MANUFACTURERADMIN : "ROLE_MANUFACTURERADMIN",
  ROLE_MANUFACTURERSTAFF : "ROLE_MANUFACTURERSTAFF",
  ROLE_MANUFACTURERIVR: "ROLE_MANUFACTURERIVR",
  ROLE_MANUFACTURERSERVICE: "ROLE_MANUFACTURERSERVICE",
  ROLE_PRACTICESTAFF : "ROLE_PRACTICESTAFF",
  ROLE_BILLER : "ROLE_BILLER",
  ROLE_AGENCYADMIN : "ROLE_AGENCYADMIN",
  ROLE_AGENCYSTAFF : "ROLE_AGENCYSTAFF",
  ROLE_ACCOUNTEXECUTIVE : "ROLE_ACCOUNTEXECUTIVE",
  ROLE_ONLY_CREATE: "ONLY_CREATE",
  ROLE_PROVIDER: "ROLE_PROVIDER",
  ROLE_PRACTICE_TX: "ROLE_PRACTICE_TX",
  ROLE_SUPERADMIN: "ROLE_SUPERADMIN",
  ROLE_PRACTICE_USER_PRU: "ROLE_PRACTICE_USER(PRU)"
};

export const PRACTICE_USER = "Practice Users";
export const AGENCY_USER = "Agency Users";
export const MANUFACTURE_USER = "Manufacturer Users";

export const AGREEMENT_STATUS = {
  INITIATED : "INITIATED",
  PRACTICE_SIGNED : "PRACTICE SIGNED",
  EXECUTED : "EXECUTED",
  DELETED : "DELETED",
  HELD : "HELD"
};

export const AGREEMENT_REQUEST_STATUS = {
  REQUESTED: "REQUESTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  IN_PROGRESS: "IN PROGRESS",
};

export const AGREEMENT_ACTIONS = {
  DELETE : "DELETE",
  PREVIEW : "PREVIEW",
  INITIATE : "INITIATE",
  INACTIVATE : "INACTIVATE",
  AGREEMENT: "AGREEMENT",
  EXPORT: "EXPORT",
  VIEW_AUDIT: "VIEW_AUDIT" // CS-2070
}

export const PRODUCT_STATUS = {
  PLACED: "PLACED",
  PENDING: "PENDING",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
  PROCESSING: "PROCESSING",
  DELAYED: "DELAYED"
};

//CS-1164 START
export const ORDER_AVAILABILITY = {
  AVAILABLE: "AVAILABLE",
  APPLIED: "APPLIED",
  RETURN_INITIATED : "RETURN_INITIATED",
  RETURN_PENDING : "RETURN_PENDING",
  RETURN_REJECTED : "RETURN_REJECTED",
  RETURNED : "RETURNED"
};
//CS-1164 END

export const CLAIM_STATUS = {
  NOT_READY: "NOT READY",
  READY: "READY",
  CLAIM_FILED: "CLAIM FILED",
  COMPLETED: "COMPLETED",
  UNRESOLVED: "UNRESOLVED",
};

export const ORDER_INVOICE_STATUS = {
  PENDING: "PENDING",
  PARTIAL: "PARTIAL",
  INVOICED: "INVOICED",
};

export const ORDER_IVR_STATUS = {
  WITH_IVR : "WITH_IVR",
  WITHOUT_IVR : "WITHOUT_IVR"
}

export const ORDERTYPE = {
  DIRECT_ORDER : "Direct Purchase Order",
  CONSIGNMENT_ORDER : "Consignment Order",
  DIRECT_ORDER_WITHOUT_IVR: "Direct Order Without Ivr",
  PAST_ORDER: "Past Order",
  ORDERED_FROM_PATIENT_LIST: "orderedFromPatientList"
};

export const BENEFIT_SUMMARY_STATUS = {
  DENIED : "DENIED",
  NEED_MORE_INFO: "NEEDS_MORE_INFO",
  PRE_AUTH: "PRE_AUTH",
  VERIFIED: "VERIFIED"
}

export const PRODUCTS_DOCUMENT_TYPE = {
  PRODUCT_DOCUMENT : "Document",
	PRODUCT_TEMPLATE : "Template",
};

export const EXTERNAL_LINK_TYPE = {
  PRODUCT_DOCUMENT : 'Product Document',
  EXTERNAL_URL : "External URL"
}

export const PRODUCT_DOCUMENT_STATUS = {
  PENDING: "PENDING",
  FEEDBACK: "FEEDBACK",
  DEV: "DEV",
  STAGE: "STAGE",
  LIVE: "LIVE",
  INACTIVE: "INACTIVE"
};

export const PRODUCT_DOCUMENT_PUBLISH_STATUS = {
  PUBLISHED: "PUBLISHED",
  NOT_PUBLISHED: "NOT PUBLISHED",
};

export const PRODUCT_DOCUMENT_TYPES = {
  IVR_FORM: "IVR_FORM",
  ORDER_FORM: "ORDER_FORM",
  SERVICE_AGREEMENT: "SERVICE_AGREEMENT",
  TISSUE_TRACKING_FORM: "TISSUE_TRACKING_FORM",
  RETURN_FORM: "RETURN_FORM"
};

export const PRODUCT_DOCUMENT_TYPES_TITLE_CASE = {
  IVR_FORM: "Ivr Form",
  ORDER_FORM: "Order Form",
  SERVICE_AGREEMENT: "Service Agreement",
  TISSUE_TRACKING_FORM: "Tissue Tracking Form",
  RETURN_FORM: "Return Form"
};

export const IVR_STATUS = {
  NEEDS_MORE_INFO : "NEEDS MORE INFO",
  PRE_AUTH: "PRE-AUTH",
  SUBMITTED : "SUBMITTED",
  DENIED : "DENIED",
  VERIFIED : "VERIFIED",
  DRAFTED : "DRAFTED",
  RESPOND: "RESPOND",
  CREATE: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  VIEW: "VIEW",
  NOTE: "NOTE",
  COPY: "COPY",
  DUPLICATE: "DUPLICATE",
  CANCEL: "CANCEL",
  CANCELED: "CANCELED",
  EMAIL_SETTINGS:"EMAIL_SETTINGS",
  EXPORT: "EXPORT",
  VOID: "VOID"
};
export const AUDIT_ENTITYS={
  IVRAUDIT: "IVRAUDIT",
  ORDERAUDIT: "ORDERAUDIT",
  USERAUDIT:"USERAUDIT",
  PRACTICEAUDIT:"PRACTICEAUDIT",
  MANUFACTUREAUDIT:"MANUFACTUREAUDIT",
  INVOICEAUDIT:"INVOICEAUDIT", // CS-1532
  PATIENTAUDIT:"PATIENTAUDIT",
  PRESCRIPTIONAUDIT: "PRESCRIPTIONAUDIT", // CS-2073
}

export const PRESCRIPTION_ACTIONS = {
  VIEW_PDF: "VIEW_PDF",
  VIEW_RESPONSE_JSON: "VIEW_RESPONSE_JSON",
  /** Gate 1 pharmacy license ship-to hard block (compliance evidence). */
  RX_GATING_BLOCKED: "RX_GATING_BLOCKED",
  /** Prescriber confirmation / acknowledgment (compliance evidence). */
  PRESCRIBER_CONFIRMATION: "PRESCRIBER_CONFIRMATION",
};

export const USER_ACTIONS = {
  PERMISSION: "PERMISSION",
}

export const ORDER_ACTIONS = {
  RETURN: "RETURN",
  TRACKING: "TRACKING",
  DETAILS: "DETAILS",
  FULFILL: "FULFILL",
  MANAGE_RETURN: "MANAGE_RETURN",//CS-1164 
  BILLING: "BILLING",
  REORDER: "REORDER",
  CANCEL: "CANCEL",
  EXPORT: "EXPORT",
  SIGNORDER: "SIGNORDER",
  MANAGE_RE_RETURN : "MANAGE_RE_RETURN",
  UPDATE : "UPDATE", //CS-1560
  ACTIVITY_CENTER: "ACTIVITY_CENTER",
};

export const CLAIM_ACTIONS = {
  CLAIMSECTION: "CLAIMSECTION",
}

export const ORDER_STATUS = {
  PLACED : "PLACED",
  PENDING : "PENDING",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
  PROCESSING: "PROCESSING",
};

export const AGENCY_STATUS = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  INACTIVATE: "INACTIVATE",
  EXPORT: "EXPORT" // CS-1156
};

export const PRACTICE_STATUS = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  PREVIEW: "PREVIEW",
  APPROVE: "APPROVE",
  ACHIEVE: "ACHIEVE",
  IMPORT_BAA: "IMPORT_BAA",
  INACTIVATE: "INACTIVATE",
  EXPORT: "EXPORT", // CS-1370
}

//CS-1395 - Start
export const PROVIDER_USER_ACTION_BUTTON = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  ADD: "ADD",
  DELETE: "DELETE",
}

// CS-1405 - Start
export const AUDIT_ACTIONS = {
  EXPORT: "EXPORT"
}
// CS-1405 - End

export const COMMISSION_STATUS = {
  CREATE: "CREATE",
  EDIT: "EDIT",
}

export const INVOICE_STATUS = {
  INVOICE: "INVOICE",
  COMMISSION: "COMMISSION",
  AGENCY: "AGENCY",
  OVERRIDE: "OVERRIDE",
}

// export const INVOICE_SEARCH_FIELDS = {
//   INVOICE_NUMBER: "INVOICE_NUMBER",
//   SERIAL_NUMBER : "INVOICE_NUMBER",
//   ORDER_NUMBER: "ORDER_NUMBER",
//   INVOICE_STATUS: "INVOICE_STATUS",
//   INVOICE_DATE_RANGE: "INVOICE_DATE_RANGE",
//   MANUFACTURE: "MANUFACTURE",
//   PRACTICE: "PRACTICE",
//   AGENCY: "AGENCY",
//   V3_PAY_STATUS: "V3_PAY_STATUS",
//   AGY_PAY_STATUS: "AGY_PAY_STATUS",
//   OVR_AGY_PAY_STATUS: "OVR_AGY_PAY_STATUS",
//   COMMISSION_PERIOD: "COMMISSION_PERIOD",
// }

export const INVOICE_ACTION={
  CREDIT_MEMO:'CREDIT_MEMO',
  ADD_PAYMENT:'RECORD_PAYMENT',
  EDIT_INVOICE:'EDIT_INVOICE',
  STRIPE_PAYMENT:'STRIPE_PAYMENT',
  CLOSE_INVOICE:'CLOSE_INVOICE', // CS-1532
  EXPORT: "EXPORT",
  LATE_FEE: "LATE_FEE",
  SHARE_INVOICE: "SHARE_INVOICE", // CS-1666
  ACTIVITY_CENTER: "ACTIVITY_CENTER",
}

export const MANUFACTURE_ACTIONS = {
  CREATE: "CREATE",
  EDIT: "EDIT",
}

export const EXPORTABLE_ITEMS = {
  INVOICE: "INVOICE",
  ORDER: "ORDER",
  PRACTICE: "PRACTICE",
  PRACTICE_DETAILS: "PRACTICE_DETAILS",
  AGREEMENT: "AGREEMENT",
  AGREEMENT_LIST: "AGREEMENT_LIST",
  AGENCY: "AGENCY",
  AGENCY_LIST: "AGENCY_LIST",
  AGENCY_DETAILS: "AGENCY_DETAILS",
  IVR: "IVR",
  IVR_LIST: "IVR_LIST",
  ORDER_SSV: "ORDER_SALES_SHEET_VERSION",
  AUDIT_LOG: "AUDIT_LOG", // CS-1405
  COMMISSION: "COMMISSION",
  PAYMENT: "PAYMENT",
  USER: "USER",
  USER_DETAILS: "USER_DETAILS",
  // CS-1685 - Start
  PRODUCTS: "PRODUCTS",
  PRODUCTS_DETAILS: "PRODUCTS_DETAILS",
  MANUFACTURER: "MANUFACTURER",
  MANUFACTURER_DETAILS: "MANUFACTURER_DETAILS",
  PROVIDER: "PROVIDER",
  BAA: "BAA", 
  // CS-1685 - End
  PATIENTS: "PATIENTS", //CS-1700 
  PATIENT_DETAILS: "PATIENT_DETAILS", //CS-1700
  SERVICE_SUBSCRIPTION: "SERVICE_SUBSCRIPTION", // CS-1706
  EXPLORE_MARKET: "EXPLORE_MARKET", // CS-1728
}

export const BAA_STATUS = {
  SIGNED : "SIGNED",
  INACTIVE : "INACTIVE", //CS-1696    
}

export const BAA_CONTRACT_TYPES = {
  PRACTICE : "PRACTICE",
  USER : "USER" 
}

export const BAA_ACTIONS = {
  SIGN : "SIGN",
  PREVIEW : "PREVIEW"
}

export const EXPORT_ACTIONS = {
  EXPORT_SS_DETAIL : "EXPORT_SS_DETAIL",
}

export const PROVIDER_LIST_ACTIONS = {
  CREATE_PROVIDER_USER: "CREATE_PROVIDER_USER",
  VIEW: "VIEW",
}

export const PATIENT_STATUS = {
  // COMPLETED: "COMPLETED",
  DRAFTED: "DRAFTED",
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
}

export const PATIENT_LIST_ACTIONS = {
  CREATE_PATIENT: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  CREATE_ORDER: "ORDER",
  VIEW_DETAILS: "DETAILS",
  HISTORY : "HISTORY",
  PVERIFY : "PVERIFY",
  RECORD_TX : "RECORD_TX",
  CREATE_IVR: "IVR",
  CLOSE_PATIENT: "CLOSE_PATIENT",
  REOPEN_PATIENT: "REOPEN_PATIENT",
  REQUEST_RX: "REQUEST_RX", // CS-2075
}

export const PATIENT_IVR_INFO_TYPES = {
  EMAIL: "EMAIL",
  ADDRESS: "ADDRESS",
  FACE_SHEET: "FACESHEET",
  PRIMARY_INSURANCE: "PRIMARY_INSURANCE",
  SECONDARY_INSURANCE: "SECONDARY_INSURANCE",
  MEDICAL_NOTES: "SUPPORTING_DOCUMENT",
  IMAGE_OF_WOUNDS: "IMAGEOF_WOUNDS",
  WOUND_INFO: "WOUND_INFO",
  NAME_CHANGE: "NAME_CHANGE",
  SURGICAL_INFO: "SURGICAL_INFO",
}

export const WOUND_TYPES={
  SURGICAL_INCISION:"Surgical Incision"
}

export const INVOICE_DETAIL_VIEW_ACTIONS = {
  AGENCY: "AGENCY",
  OVERRIDE: "OVERRIDE",
}

export const PAYMENT_ACTIONS = {
  VOID: "VOID",
  DETAIL: "DETAIL",
  RECORD_PAYMENTS: "RECORD_PAYMENTS"
}

export const PAYMENT_STATUS = {
  RECEIVED: "RECEIVED",
  VOID: "VOID",
  //CS-1512 - New payment status
  FAILED: "FAILED", 
  PROCESSING: "PROCESSING",
  CANCELLED: "CANCELED",
}
//CS-1244 - EMR
export const MSG_PATIENT_NOT_FOUND_IN_EMR = "NO_PATIENT_IN_EMR";
export const PATIENT_INSURANCE_NOT_FOUND_IN_EMR = "NO_INSURANCE_FOUND";
//

// CS-1808 START - Product Category Label Decoupling

/** Codetable tablename for product categories. Single source of truth for the lookup key. */
export const PRODUCT_CATEGORY_CODETABLE = "prdProductCategory";

/** Codetable tablename for commission/service fee entity types (keyName "V3" -> displayValue from DB). */
export const COMMISSION_TYPE_CODETABLE = "CommissionType";

/** Codetable tablename for ISR sidebar/page access. Match logged-in email to displayValue. */
export const ISR_EXPLICIT_FULL_ACCESS_CODETABLE = "ISR_EXPLICIT_FULL_ACCESS_USER_LIST";
export const ISR_EXPLICIT_FULL_ACCESS_KEY = "ISR_EXPLICIT_FULL_ACCESS";
export const ISR_COMMISSION_TYPE = "ISR";
/**
 * CommissionType codetable keynames. They are lookup aliases: helpers resolve them
 * against the codetable (case-insensitively) and send back whatever the table stores,
 * so a rename in the database does not need a client change. They double as the
 * request-body fallback for when the codetable has not loaded yet.
 */
export const COMMISSION_TYPE_V3_KEY = "V3";
export const COMMISSION_TYPE_AGENCY_KEY = "Agency";
export const COMMISSION_TYPE_OVERRIDE_KEY = "Override";
/** UI fallback when CommissionType has not loaded or has no V3/v3 displayValue. */
/** When CommissionType / V3 row or displayValue is missing, UI shows the key name. */
export const COMMISSION_TYPE_V3_DISPLAY_FALLBACK = "V3";

/** Stable keynames for product categories — used for logic/comparisons only, NEVER as display labels. */
export const PRODUCT_CATEGORY = {
  ADVANCED: "Advanced",
  CONSERVATIVE: "Conservative",
  STANDARD: "Standard",
  GENERAL: "General",
};

// CS-1808 END

// CS-1760 START - Product Config Constants (mirrors backend ProductConfigTypeEnum + ProductConfigCodeEnum)

export const PRODUCT_CONFIG_TYPE = {
  ORDER_REQUIREMENT: "ORDER_REQUIREMENT",
  AGREEMENT: "AGREEMENT",
  ORDER_WORKFLOW: "ORDER_WORKFLOW",
  PURCHASE_AND_BILL: "PURCHASE_AND_BILL",
}

export const PRODUCT_CONFIG_CODE = {
  PATIENT: "PATIENT",
  IVR: "IVR",
  PRESCRIPTION: "PRESCRIPTION",
  MODE: "MODE",
  TYPE: "TYPE",
  ENABLE: "ENABLE",
}

export const PRODUCT_CONFIG_VALUE = {
  // ORDER_REQUIREMENT values
  REQUIRED: "REQUIRED",
  OPTIONAL: "OPTIONAL",
  EXCLUDED: "EXCLUDED",
  // AGREEMENT MODE values
  MANDATORY: "MANDATORY",
  AUTO: "AUTO",
  NONE: "NONE",
  // ORDER_WORKFLOW TYPE values
  SKIN_SUB: "SKIN_SUB",
  COLLAGEN: "COLLAGEN",
  OPEN_ACCESS: "OPEN_ACCESS",
  Y: "Y",
  N: "N",
}

// CS-1760 END

export const PRACTICE_TYPE = {
  WOUND_CARE : "Wound Care Only", //CS-1650
  SURGICAL: "Surgical Only",
  WOUND_CARE_AND_SURGICAL: "Wound Care and Surgical"
}
export const PRACTICE_SPECIALIZATION = {
  SURGICAL: "Surgical",
  WOUND_CARE_AND_SURGICAL: "Wound Care and Surgical"
}

export const CAN_ACCESS_USER_PERMISSION = {
  VIEW: "VIEW",
  EDIT: "EDIT",
}

// CS-1766 - Product Shipping token action values
export const PRODUCT_SHIPPING_ACTIONS = {
  VIEW: "VIEW",
  EDIT: "EDIT",
};

 export const adminRoleId = 1;
 export const practiceAdminRoleId = 2;
 export const practiceStaffRoleId = 3;
 export const billerRoleId = 4;
 export const agencyAdminRoleId = 5;
 export const accountExecutiveRoleId = 6;
 export const manufacturerAdminRoleId = 7;
 export const manufacturerStaffRoleId = 8;
 export const manufacturerIvrRoleId = 9;
 export const manufacturerServiceId = 10;
 export const providerRoleId = 11;
 export const agencyStaffRoleId = 12;

 export const TWO_FACTOR_METHOD_TYPE_EMAIL = "EMAIL";
export const TWO_FACTOR_METHOD_TYPE_MOBILE = "MOBILE";
export const TWO_FACTOR_METHOD_TYPE_GOOGLE_AUTH = "GOOGLE_AUTH";
export const TWO_FACTOR_METHOD_TYPE_MICROSOFT_AUTH = "MICROSOFT_AUTH";
export const TWO_FACTOR_REGISTRATION = "REGISTRATION";
export const TWO_FACTOR_AUTHENTICATION = "AUTHENTICATION";
export const TWO_FACTOR_VERIFICATION_CODE_LENGTH = 6;
export const TWO_FACTOR_SIGNIN = "REGISTRATION";
export const TWO_FACTOR_VERIFICATION = "VERIFICATION";


export const IVR_STATUS_LIST = "IVRStatus";
export const PRODUCT_AGREEMENT_STATUS_LIST = "AgreementStatus";
export const PRODUCT_AGREEMENT_VALIDITY_LIST = "AgreementValidity";//CS-1288
export const PRODUCT_AGREEMENT_TYPE_SINGLE = "SINGLE";
export const PRODUCT_AGREEMENT_TYPE_MULTI = "MULTI";
export const NOTIFICATION_TYPE_LIST = "notificationType";
export const NOTIFICATION_TYPE = "EMAIL";
export const ACTION_TYPE = "ActionType";
export const ENTITY_TYPE = "EntityName";
export const INVOICE_DUE_DATE = "InvoiceDueDate";
export const INVOICE_DUE_DAYS = "InvoiceDueDays";
export const TEMPLATE_LEVELS = "TemplateLevels";
export const TIER_PRICE_CODETABLE = "TierPrices";


export const FETCH_TYPE_SUCCESS = "success";
export const SUCCESS="SUCCESS";

export const RESPONSE_CODES = {
  SUCCESS_CODE : "V3OK",
  FAILED_CODE : "V3ER001"
};

export const SHIFT_KEY = 9;
export const SHIFT_TEXT = "V3BioMed";

export const MSG_ACTIVE_PRODUCT_AGREEMENT_FOUND = "There is an active agreement already exists for the given inputs.";
export const MSG_NO_LIVE_SERVICE_AGREEMENT_FOR_MANUFACTURER =
  "Multi-product agreement is not configured for the selected manufacturer.";

export const MSG_NO_AGENCY_FOUND = "No Agency Found";
export const MSG_NO_USER_FOUND = "No User Found";
export const MSG_NOT_AN_ACTIVE_EXECUTIVE = "Given Practice Executive is not active.";
export const MSG_PRACTICE_EXECUTIVE_NOT_FOUND = "No Practice Executive Found";

export const MSG_PRACTICE_BILLER_NOT_FOUND = "No Practice Biller Found";
export const MSG_NOT_AN_ACTIVE_BILLER = "Given Practice Billler is not active.";
export const MSG_BILLER_NOT_FOUND = "No Biller Found";
// export const MSG_ORDER_NOT_COMPLETED= "Orders are still pending to be Invoiced.";
export const MSG_ORDER_NOT_COMPLETED= "This practice has pending orders that haven’t been invoiced yet. Please invoice all orders before changing the agency.";

export const YES = "Yes"
export const NO = "No"

export const USER_ROLE_ENTITY_NAMES = {
  ADMIN: "ADMIN",
  PRACTICE: "PRACTICE",
  BILLER: "BILLER",
  AGENCY: "AGENCY",
  ACCOUNTEXECUTIVE: "ACCOUNTEXECUTIVE",
  MANUFACTURER: "MANUFACTURER",
  PROVIDER: "PROVIDER"
}

export const NOTIFICATION_TARGET_ENTITY_NAMES = {
  USER: "USER",
  ADMIN: "ADMIN",
  PRACTICE: "PRACTICE",
  AGENCY: "AGENCY",
  MANUFACTURER: "MANUFACTURER",
  EVERYONE: "EVERYONE",
  SUPER_ADMIN: "SUPER ADMIN"
}

export const USAGE_TYPES = {
  PRIMARY: "Primary",
  SECONDARY: "Secondary",
  ANCILLARY: "Ancillary"
}

export const CART_OPTIONS = {
  OPTION_1: "Option 1",
  OPTION_2: "Option 2"
}

//CS-1297 - Start
export const PVERIFY_KEY = "pverifyPatients";
//CS-1297 - End

export const CLAIM_TIMELINE_ENTRIES = {
  SUBMITTED: "The claim has been submitted",
  DENIED: "The claim has been denied",
  APPEALED: "The claim has been appealed",
  REIMBURSED: "The claim has been reimbursed"
}

export const CAN_ACCESS_KPI_CONSTANTS = {
  ACTIVE_USERS_KPI: "ACTIVE_USERS_KPI",
  ACTIVE_PRACTICES_KPI: "ACTIVE_PRACTICES_KPI",
  WEEKLY_SALES_KPI: "WEEKLY_SALES_KPI",
  IVR_DONUT: 'IVR_DONUT',
  ORDER_DONUT: 'ORDER_DONUT',
  PATIENTS_KPI: "PATIENTS_KPI",
  WEEKLY_ORDERS_KPI: "WEEKLY_ORDERS_KPI",
  RECORD_TX_KPI: 'RECORD_TX_KPI'
}

export const CAN_ACCESS_KPI_EXPORT_CONSTANTS = {
  ACTIVE_USERS: "ACTIVE_USERS",
  ACTIVE_PRACTICES: "ACTIVE_PRACTICES",
  WEEKLY_SALES: "WEEKLY_SALES",
  TOTAL_PATIENTS: "TOTAL_PATIENTS",
  WEEKLY_ORDERS: "WEEKLY_ORDERS"
}

//CS-1563
export const CAN_ACCESS_STRIPE_CONFIG = {
  ADD: "ADD",
  EDIT: "EDIT",
  VIEW: "VIEW",
}
//

export const CAN_ACCESS_NETSUITE_CONFIG = {
  ADD: "ADD",
  EDIT: "EDIT",
  VIEW: "VIEW",
}

// CS-2075 START — practice_pharmacy_config keys (must match backend resolvePharmacyKey)
export const PHARMACY_CONFIG_KEY_SANDSRX = "sandsrx";
export const PHARMACY_CONFIG_KEY_GENESIS = "genesis";
export const PHARMACY_CONFIG_BILLING_CODE = "billing_code";

/**
 * Keyword match order — Genesis first, then SandsRx — same as the backend.
 * A future pharmacy is one new const here plus an entry in this list.
 */
export const PHARMACY_CONFIG_KEYS = [
  PHARMACY_CONFIG_KEY_GENESIS,
  PHARMACY_CONFIG_KEY_SANDSRX,
] as const;

export const PHARMACY_CONFIG_BILL_TO_PRACTICE_PROVIDER = "PRACTICE_PROVIDER";
export const PHARMACY_CONFIG_BILL_TO_PATIENT = "PATIENT";
// CS-2075 END
